import { gql } from '@apollo/client';

export const fetchCloudLicense = gql`
  query fetchCloudLicense($params: SearchCloudLicenseParams!) {
    cloudLicense(params: $params) {
      accountId
      accountName
      accountOwnerEmail
      aliases
      baseProduct
      billingContactEmail
      billingCycle
      billingStatus
      businessKey
      cloudSiteId
      cloudSiteUrl
      createdDate
      firstPeriodEndDate
      firstPeriodStartDate
      hoursFromSupendedDate
      isAddon
      isCloud
      jobStatuses {
        renameInProgress
        deleteInProgress
        reactivateInProgress
        deactivateInProgress
      }
      latestPeriodEndDate
      latestPeriodStartDate
      licenseLevel
      migrated
      planType
      platform
      productId
      productName
      regions
      renewalAction
      sen
      sourceSystem
      sources
      unitCount
      unitLabel
      updatedDate
      shipToParty {
        id
        name
      }
    }
  }
`;
